var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form tab-content", attrs: { id: "activities-tab" } },
    [
      _vm.currentSection === "activitiesList"
        ? _c("activities-list", {
            attrs: {
              "object-uuid": _vm.objectUuid,
              "object-layer": _vm.objectLayer,
              "action-type": _vm.actionType
            },
            on: {
              openActivity: function($event) {
                _vm.selectedActivityUUID = $event
              },
              addActivity: function($event) {
                _vm.activityCreate = true
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentSection === "activityCreate"
        ? _c("activity-create", {
            attrs: {
              "object-uuid": _vm.objectUuid,
              "object-layer": _vm.objectLayer,
              "object-data": _vm.objectData
            },
            on: {
              close: function($event) {
                return _vm.close($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentSection === "activityDetails"
        ? _c("activity-details", {
            attrs: {
              "activity-uuid": _vm.selectedActivityUUID,
              "action-type": _vm.actionType
            },
            on: {
              openTask: function($event) {
                _vm.selectedTaskUUID = $event
              },
              addTask: function($event) {
                _vm.taskCreate = true
              },
              return: _vm.returnToActivitiesList
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentSection === "taskCreate"
        ? _c("task-create", {
            attrs: {
              "object-layer": _vm.objectLayer,
              activityUuid: _vm.selectedActivityUUID,
              objectData: _vm.objectData
            },
            on: {
              close: function($event) {
                _vm.taskCreate = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentSection === "taskDetails"
        ? _c("task-details", {
            attrs: {
              taskUuid: _vm.selectedTaskUUID,
              "action-type": _vm.actionType,
              activityUUID: _vm.selectedActivityUUID,
              width: _vm.width
            },
            on: { return: _vm.returnToActivityDetails }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28a4887d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28a4887d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/ActivitiesTab.vue
// module id = null
// module chunks = 